import { render, staticRenderFns } from "./StoryDescriptionTextPart.vue?vue&type=template&id=3b2305b3&"
import script from "./StoryDescriptionTextPart.vue?vue&type=script&lang=js&"
export * from "./StoryDescriptionTextPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports